import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, watch } from "vue";

import AddToBriefcaseButton, {
  MinimumBriefcaseKeys,
} from "@/components/buttons/AddToBriefcaseButton.vue";
import HeadMetadata from "@/components/HeadMetadata.vue";
import NotFoundComponent from "@/components/404.vue";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { usePanels } from "@/composition/usePanels";
import { useSessionStore } from "@/pinia/session";
import { storeToRefs } from "pinia";
import { useAppStore } from "@/pinia/app";
import { VignetteRoutes } from "@/types";
import KeywordSearch from "@/components/fields/KeywordSearch.vue";

interface Props {
  briefcaseObj: MinimumBriefcaseKeys;
  displayNotFound: boolean;
  hasAccessToProfile: boolean;
  img?: string;
  isUnlocked: boolean;
  pageTitle: string;
  loaded: boolean;
  panelsOpenedByDefault: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileWrapper',
  props: {
    briefcaseObj: null,
    displayNotFound: { type: Boolean },
    hasAccessToProfile: { type: Boolean },
    img: null,
    isUnlocked: { type: Boolean },
    pageTitle: null,
    loaded: { type: Boolean },
    panelsOpenedByDefault: null
  },
  emits: ["headshot-error"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  briefcaseObj: MinimumBriefcaseKeys;
  displayNotFound: boolean;
  hasAccessToProfile: boolean;
  img?: string;
  isUnlocked: boolean;
  pageTitle: string;
  loaded: boolean;
  panelsOpenedByDefault: string[];
};

const appStore = useAppStore();
const { pageName } = storeToRefs(appStore);





const {
  briefcaseObj,
  displayNotFound,
  hasAccessToProfile,
  img,
  isUnlocked,
  loaded,
  pageTitle,
} = toRefs(props);
watch(pageTitle, (v) => {
  if (v) pageName.value = v;
});

const showProfile = computed(() => loaded.value && !displayNotFound.value);
const isLoading = computed(() => !loaded.value);

const mainPanelRef = ref(null);

const { allPanelsExpanded, panels, togglePanels } = usePanels(
  props.panelsOpenedByDefault,
  mainPanelRef
);

const sessionStore = useSessionStore();
const { isWebUser, hasVignetteAccess } = storeToRefs(sessionStore);

return { __sfc: true,appStore, pageName, emits, props, briefcaseObj, displayNotFound, hasAccessToProfile, img, isUnlocked, loaded, pageTitle, showProfile, isLoading, mainPanelRef, allPanelsExpanded, panels, togglePanels, sessionStore, isWebUser, hasVignetteAccess, AddToBriefcaseButton, HeadMetadata, NotFoundComponent, NjBtn, VignetteRoutes, KeywordSearch }
}

})